
<!--@if (authService.authStatusChecked()) {-->

<!--    <app-sidebar></app-sidebar>-->

<!--    <div class="main-content">-->

<!--        <app-header></app-header>-->

<!--        <router-outlet></router-outlet> &lt;!&ndash; Aquí se renderizan las rutas hijas &ndash;&gt;-->

<!--    </div>-->

<!--} @else {-->

<!--    <div class="app-loading-spinner">-->

<!--        &lt;!&ndash; Aquí puedes poner un MatSpinner o cualquier otro indicador de carga &ndash;&gt;-->

<!--        <p>Cargando...</p>-->

<!--    </div>-->

<!--}-->

<app-sidebar></app-sidebar>

<div     class="main-content transition d-flex flex-column"
         [ngClass]="{'active': isToggled}"
>

    <app-header></app-header>

    <router-outlet></router-outlet> <!-- Aquí se renderizan las rutas hijas -->

</div>
